import { Roles } from '../../constants/security/roles.constants';
import { Systems } from '../../constants/security/systems.constants';

const systemsEnabled = {
    [Systems.EWIS]: { enabled: true },
    [Systems.RiskAppetite]: { enabled: true },
    [Systems.RDARR]: { enabled: true },
    [Systems.RiskCulture]: { enabled: false },
    [Systems.Indicators]: { enabled: true, roles: [Roles.Admin] },
};

export function IncludeSystem(system, user, featureCheck) {
    let featureEnabled = (s) => systemsEnabled[s]?.enabled;
    if (featureCheck) {
        featureEnabled = (s) => featureCheck(s, systemsEnabled[s]?.enabled ?? false);
    }
    return (
        featureEnabled(system) &&
        user?.remoteSystems?.includes(system) &&
        (systemsEnabled[system]?.roles
            ? user?.roles?.some((role) => systemsEnabled[system]?.roles?.includes(role))
            : true)
    );
}
